import React, { useState } from 'react';
import { ethers } from 'ethers';

const WalletConnect = ({ onConnect }) => {
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState('');

  const connectMetaMask = async () => {
    setConnecting(true);
    setError('');

    try {
      // Check if MetaMask is installed
      if (!window.ethereum || !window.ethereum.isMetaMask) {
        throw new Error('MetaMask not installed or not detected');
      }

      // Get all ethereum providers
      const providers = window.ethereum.providers || [window.ethereum];
      
      // Find MetaMask provider specifically
      const metamaskProvider = providers.find(provider => provider.isMetaMask && !provider.isPhantom);
      
      if (!metamaskProvider) {
        throw new Error('MetaMask provider not found');
      }

      // Request accounts specifically from MetaMask
      await metamaskProvider.request({ 
        method: 'eth_requestAccounts',
        params: []
      });
      
      const provider = new ethers.BrowserProvider(metamaskProvider);
      const signer = await provider.getSigner();
      const account = await signer.getAddress();

      onConnect(account, 'MetaMask');
    } catch (error) {
      setError(error.message);
    } finally {
      setConnecting(false);
    }
  };

  const connectPhantom = async () => {
    setConnecting(true);
    setError('');

    try {

      // First check if Phantom is installed
      if (!window.phantom) {
        throw new Error('Phantom wallet not installed');
      }

      // Try to connect to Phantom's Ethereum wallet first
      if (window.phantom.ethereum) {
        try {


                // Get all ethereum providers
      const providers = window.phantom.providers || [window.ethereum];
      
      // Find MetaMask provider specifically
      const phantomProvider = providers.find(provider => !provider.isMetaMask && provider.isPhantom);
      
      if (!phantomProvider) {
        throw new Error('phantom provider not found');
      }



          await phantomProvider.request({ 
            method: 'eth_requestAccounts',
            params: []
          });
          
          const provider = new ethers.BrowserProvider(phantomProvider);
          const signer = await provider.getSigner();
          const account = await signer.getAddress();

          onConnect(account, 'Phantom');
          return;
        } catch (ethError) {
          console.log('Phantom Ethereum connection failed:', ethError.message);
        }
      }

      // Fallback: Check if Phantom injected itself as ethereum provider
      if (window.ethereum && window.ethereum.isPhantom) {
        await window.ethereum.request({ 
          method: 'eth_requestAccounts',
          params: []
        });
        
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        const account = await signer.getAddress();

        onConnect(account, 'Phantom');
        return;
      }

      // If neither works, show helpful error
      throw new Error('Phantom Ethereum wallet not available. Please switch to Ethereum in Phantom wallet settings and refresh the page.');

    } catch (error) {
      setError(error.message);
    } finally {
      setConnecting(false);
    }
  };

  return (
    <div className="wallet-connect">
      <h2>Connect Your Wallet</h2>
      <p>Choose your preferred EVM wallet to get started</p>

      <div className="wallet-buttons">
        <button
          onClick={connectMetaMask}
          disabled={connecting}
          className="wallet-btn metamask-btn"
        >
          <img 
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjQxOSAyNy4yODZMMzEuNzIgMjMuNjY3TDMwLjE5NyAyNi4zNDNMMzEuNDE5IDI3LjI4NloiIGZpbGw9IiNFMjc2MjYiLz4KPC9zdmc+" 
            alt="MetaMask"
          />
          {connecting ? 'Connecting...' : 'Connect MetaMask'}
        </button>


      </div>

      {error && (
        <div className="error-message">
          <p>{error}</p>
        </div>
      )}

      <div className="wallet-note">
        <p> <a href="https://metamask.io" target="_blank" rel="noopener noreferrer">Get MetaMask</a></p>
        {/* <p> <a href="https://phantom.app" target="_blank" rel="noopener noreferrer">Get Phantom</a> - Make sure to enable Ethereum support</p> */}
      </div>
    </div>
  );
};

export default WalletConnect;